
import { connect,  } from "react-redux";
import { Link } from "react-router-dom";
import React, {  useState, useEffect } from "react";
import { Col, FormGroup,  } from "reactstrap";
import { FiSearch } from "react-icons/fi";
import {
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdChevronRight,
  MdKeyboardArrowDown,
  MdAddBox,
  MdIndeterminateCheckBox,

  MdAdd,
  MdRemove,
} from "react-icons/md";
import CheckboxTree from "react-checkbox-tree";
import "./filter-navbar.css";
import { dropdownPropertyField } from "../actions/propertyFieldAction";
import PerfectScrollbar from "react-perfect-scrollbar";
import CloseIcon from '@mui/icons-material/Close';
import Nodes from "../Helpers/nodesList.js";
const icons = {
  check: (
    <MdCheckBox
      className="rct-icon rct-icon-check"
      sx={{ color: "#000!important" }}
    />
  ),
  uncheck: <MdCheckBoxOutlineBlank className="rct-icon rct-icon-uncheck" />,
  halfCheck: (
    <MdIndeterminateCheckBox className="rct-icon rct-icon-half-check" />
  ),
  expandClose: <MdChevronRight className="rct-icon rct-icon-expand-close" />,
  expandOpen: <MdKeyboardArrowDown className="rct-icon rct-icon-expand-open" />,
  expandAll: <MdAddBox className="rct-icon rct-icon-expand-all" />,
  collapseAll: (
    <MdIndeterminateCheckBox className="rct-icon rct-icon-collapse-all" />
  ),
  parentClose: <MdAdd className="rct-icon rct-icon-parent-close" />,
  parentOpen: <MdRemove className="rct-icon rct-icon-parent-open" />,
  // leaf: <MdInsertDriveFile className="rct-icon rct-icon-leaf-close" />
};


const FilterNavbar = ({setEnterSearch,search,setSearch,setRoom,propertyType,filterPropertyFieldText,setFilterPropertyFieldText,setPropertyType,setRentalPeriod,rentalPeriod,setFilterText,room,gender,filterText, setGender,smoking, setSmoking,pets, setPets,inhabitants, setInhabitants,label,dropdownPropertyField}) => {
  const { frontLabelsName } = label
  const lng = localStorage.getItem("prevLangFront");
  const [openZip, setOpenZip] = useState(false);
  const [checkedTree, setCheckedTree] = useState(["0"]);
  const [expandedTree, setExpandedTree] = useState(["0"]);
 const nodes = Nodes(); 
  const [nodesFiltered, setNodesFiltered] = useState();
  const [clickedTree, setClickedTree] = useState([]);
  const [page, setPage] = useState(1);

  const [open1, setOpen1] = useState(false);



  const [homeApplianceType, setHomeApplianceType] = useState([]);
  const [restrictionsType, setRestrictionsType] = useState([]);
  const [accessType, setAccessType] = useState([]);
  const [otherType, setOtherType] = useState([]);
  const [checkedPropertyFieldTree, setCheckedPropertyFieldTree] = useState([
    "0",
  ]);
  const [expandedPropertyFieldTree, setExpandedPropertyFieldTree] = useState([
    "0",
  ]);


  const [clickedPropertyFieldTree, setClickedPropertyFieldTree] = useState([]);




  const propertyFieldNodes = [
    {
      id: 3001,
      value: "3001",
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_home_appliances").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_home_appliances")[0][
              "value"
            ] || "lbl_home_appliances"
          : "lbl_home_appliances"
        : "lbl_home_appliances",
      children: homeApplianceType,
    },
    {
      id: 3002,
      value: "3002",
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_restrictions").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_restrictions")[0]["value"] ||
            "lbl_restrictions"
          : "lbl_restrictions"
        : "lbl_restrictions",
      children: restrictionsType,
    },
    {
      id: 3003,
      value: "3003",
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_access").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_access")[0]["value"] ||
            "lbl_access"
          : "lbl_access"
        : "lbl_access",
      children: accessType,
    },
    {
      id: 3004,
      value: "3004",
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_other").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_other")[0]["value"] ||
            "lbl_other"
          : "lbl_other"
        : "lbl_other",
      children: otherType,
    },
  ];

  const ArrayChangeHandler = (arr) => {
    arr.forEach((object) => {
      object.value = object._id;
    });
    const newArrayOfHomeAppliance =
      arr?.length > 0 &&
      arr.map(({ _id: id, name, ...rest }) => {
        let label=Array.isArray(name) ? name?.filter((e)=>(  (e[lng])))[0][lng]['name']:name
     
      

    
 
        return{
          id,label,...rest
      }});

    return newArrayOfHomeAppliance;
  };

  useEffect(() => {
    dropdownPropertyField("").then((res) => {
      //setIncluded1(res?.type_1);
      setHomeApplianceType(ArrayChangeHandler(res?.type_2));
      setRestrictionsType(ArrayChangeHandler(res?.type_3));
      setAccessType(ArrayChangeHandler(res?.type4));
      setOtherType(ArrayChangeHandler(res?.type5));
    });
  }, [lng]);

  const filterTree = () => {
    // Reset nodes back to unfiltered state
    if (!filterText || filterText === "" || filterText.length === 0) {
      setNodesFiltered(nodes);
      return;
    }

    const nodesFiltered = (nodes) => {
      return nodes.reduce(filterNodes, []);
    };

    setNodesFiltered(nodesFiltered);
  };

  const filterNodes = (filtered, node) => {
    const children = (node.children || []).reduce(filterNodes, []);
    if (
      // Node's label matches the search string
      node.label.toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) >
        -1 ||
      // Or a children has a matching node
      children.length
    ) {
      filtered.push({ ...node, ...(children.length && { children }) });
    }
    return filtered;
  };

  const handleZipCode = () => {
    filterTree();
    setOpenZip(!openZip);

    // setMenuOpen(!menuOpen);
  };
  
  const handleClose = () => {
    setOpen1(!open1);
  };
  
  const handlePropertyField = () => {
    // filterPropertyFieldTree();
    setOpen1(!open1);
  };

  const handleEnter = (e) => {
    if (e.target.name === "search") {
      if (e.key === "Enter") {
        setEnterSearch(e.target.value);
      }
    }
  };

  const handleClearSearch=()=>{
    setEnterSearch("")
    setSearch("")
  }

  var zipcustom
  if(checkedTree&& checkedTree[0]=="0" ){
    zipcustom=""
  }else if(checkedTree&& checkedTree[0]!="0"&& checkedTree?.toString()?.length<=16){
    zipcustom=checkedTree?.toString()
  }
  else if(checkedTree&& checkedTree[0]!="0"&& checkedTree?.toString()?.length>16){
    zipcustom= checkedTree?.toString().substring(0,16) + "..."
  }

  return (
    <div className="row " style={{ margin: 0 }}>
      <div className="list-view-main d-flex align-items-center">
        <div className="col-xl-3 col-lg-2 col-md-12 col-12 d-flex list-view-img">
          <Link to={`/properties`}>
            <img src="assets/menu.png" alt="menu" />
          </Link>
          <Link to={`/properties-list`}>
            <img src="assets/list.svg" alt="list" />
          </Link>
          <Link to={`/properties-map`}>
            <img src="assets/location.svg" alt="map"  className="icon-shadows1" />
          </Link>
        </div>
        <div className="col-xl-5 col-lg-6 col-md-12 col-12 d-flex list-view-input">
          <div className="row align-items-center w-100">
            <div className="col-lg-4 col-md-12 list-view-input1">
              <input type="text" placeholder={
                          frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_enter_zipcode"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_enter_zipcode"
                                )[0]["value"] || "lbl_enter_zipcode"
                              : "lbl_enter_zipcode"
                            : "lbl_enter_zipcode"
                        }  onClick={handleZipCode}
                        value={zipcustom}/>
              {openZip && (
                      <div className="zipcode-style">
                                                            <PerfectScrollbar
                  style={{
                 
                    maxHeight:"300px",
                    overflowX: "hidden",
                  
                    width:"100%"
                  }}
            
                 
                >
                        <CheckboxTree
                          nodes={
                             nodes
                          }
                          checked={checkedTree}
                          expanded={expandedTree}
                          expandOnClick={true}
                          onClick={(clickedTree) => setClickedTree(clickedTree)}
                          onCheck={(checkedTree) => {
                            setPage(1);
                            setCheckedTree(checkedTree);
                            setFilterText(checkedTree.toString());

                          }}
                          onExpand={(expandedTree) =>
                            setExpandedTree(expandedTree)
                          }
                          icons={icons}
                          // nativeCheckboxes={true}
                        />
                        </PerfectScrollbar>
                      </div>
                    )}
            </div>
            <div className=" col-lg-4  col-md-12 list-view-input1">
            <div style={{ position: 'relative' }}>
              <input type="text" placeholder={
                      frontLabelsName
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_search_street_name"
                          ).length > 0
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_search_street_name"
                            )[0]["value"] || "lbl_search_street_name"
                          : "lbl_search_street_name"
                        : "lbl_search_street_name"
                    }    value={search}
                    name="search"
                    onChange={(e) => setSearch(e.target.value)}
                    onKeyPress={handleEnter} />
              <FiSearch className="list-view-search-icon" />
              <div
          onClick={handleClearSearch}
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            cursor: 'pointer',
          }}
        >
          {search ? <CloseIcon />: null}
        </div>
      </div>
            </div>
            <div className="col-lg-4 col-md-12 list-view-input1">
              <select    name="select"
                            id="exampleSelect"
                            className={`set-bg-input ${!propertyType ? "has-placeholder" : ""}`}
                            style={{ width: "100%" }}
                            value={propertyType}
                            onChange={(e) => {
                              setPage(1);
                              setPropertyType(e.target.value);
                            }}>
              <option value={""}>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_select_property_type"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_select_property_type"
                                    )[0]["value"] || "lbl_select_property_type"
                                  : "lbl_select_property_type"
                                : "lbl_select_property_type"}
                            </option>
                            <option value={"detachedHouse"}>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_detached_house"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_detached_house"
                                    )[0]["value"] || "lbl_detached_house"
                                  : "lbl_detached_house"
                                : "lbl_detached_house"}
                            </option>
                            <option value={"duplex"}>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_duplex"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_duplex"
                                    )[0]["value"] || "lbl_duplex"
                                  : "lbl_duplex"
                                : "lbl_duplex"}
                            </option>
                            <option value={"tripleAptHouse"}>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_triple_apt_house"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_triple_apt_house"
                                    )[0]["value"] || "lbl_triple_apt_house"
                                  : "lbl_triple_apt_house"
                                : "lbl_triple_apt_house"}
                            </option>
                            <option value={"aptBulding"}>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_apt_building"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_apt_building"
                                    )[0]["value"] || "lbl_apt_building"
                                  : "lbl_apt_building"
                                : "lbl_apt_building"}
                            </option>
                            <option value={"townhouseTwin"}>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_townhouse_twin"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_townhouse_twin"
                                    )[0]["value"] || "lbl_townhouse_twin"
                                  : "lbl_townhouse_twin"
                                : "lbl_townhouse_twin"}
                            </option>
                            <option value={"garage"}>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_garage"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_garage"
                                    )[0]["value"] || "lbl_garage"
                                  : "lbl_garage"
                                : "lbl_garage"}
                            </option>
                            <option value={"summerHouse"}>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_summer_house"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_summer_house"
                                    )[0]["value"] || "lbl_summer_house"
                                  : "lbl_summer_house"
                                : "lbl_summer_house"}
                            </option>
                            <option value={"cotenant"}>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_co_tenant"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_co_tenant"
                                    )[0]["value"] || "lbl_co_tenant"
                                  : "lbl_co_tenant"
                                : "lbl_co_tenant"}
                            </option>
                            <option value={"hotelGesthouse"}>
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_hotel_guest_house"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_hotel_guest_house"
                                    )[0]["value"] || "lbl_hotel_guest_house"
                                  : "lbl_hotel_guest_house"
                                : "lbl_hotel_guest_house"}
                            </option>
              </select>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-lg-4 col-md-12 col-12 d-flex list-view-dropdown" style={{height:"20px"}}>
     
            
          <div className="list-view-dropdown-border mt-2">
                {/* <div className="list-view-dropdown-border"> */}
                <div className="dropdown">
                  <Link
                    class="dropdown-btn-list-view dropdown-toggle1"
                    href="#"
                    role="button"
                    id="dropdownMenuLink"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                  {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_property_room"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_property_room"
                                )[0]["value"] || "lbl_property_room"
                              : "lbl_property_room"
                            : "lbl_property_room"}
                    <i className="arrow down"></i>
                  </Link>

                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuLink"
                  >
                               <li    onClick={() => {
                  
                      setRoom([]);
                 
                  }}>
                      <Link className="dropdown-item" href="#">
                      {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_clear"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_clear"
                                      )[0]["value"] || "lbl_clear"
                                    : "lbl_clear"
                                  : "lbl_clear"}
                      </Link>
                    </li>
                    <li    onClick={() => {
               
                      setRoom(["Storage"]);
                 
                  }}>
                      <Link className="dropdown-item" href="#">
                      {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_storage"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_storage"
                                      )[0]["value"] || "lbl_storage"
                                    : "lbl_storage"
                                  : "lbl_storage"}
                      </Link>
                    </li>
                    <li   onClick={() => {
               
                      setRoom(["Studio"]);
                  
                  }}>
                      <Link className="dropdown-item" href="#">
                      {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_studio"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_studio"
                                      )[0]["value"] || "lbl_studio"
                                    : "lbl_studio"
                                  : "lbl_studio"}
                      </Link>
                    </li>
                    <li     onClick={() => {
                 
                      setRoom(["Single Room"]);
                  
                  }}>
                      <Link className="dropdown-item" href="#">
                      {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_single_room"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_single_room"
                                      )[0]["value"] || "lbl_single_room"
                                    : "lbl_single_room"
                                  : "lbl_single_room"}
                      </Link>
                    </li>
                    <li  onClick={() => {
                 
                      setRoom(["2"]);
                  
                  }}>
                      <Link className="dropdown-item" href="#">
                 2
                      </Link>
                    </li>
                    <li  onClick={() => {
                   
                      setRoom(["3"]);
                   
                  }}>
                      <Link className="dropdown-item" href="#">
                  3
                      </Link>
                    </li>
                    <li onClick={() => {
                
                      setRoom(["4"]);
                  
                  }}>
                      <Link className="dropdown-item" href="#">
                  4
                      </Link>
                    </li>
                    <li  onClick={() => {
             
                      setRoom(["5"]);
                   
                  }}>
                      <Link className="dropdown-item" href="#">
                    5
                      </Link>
                    </li>
                    <li  onClick={() => {
                
                      setRoom(["6"]);
                   
                  }}>
                      <Link className="dropdown-item" href="#">
                    6
                      </Link>
                    </li>
                    <li  onClick={() => {
                 
                      setRoom(["7"]);
                   
                  }}>
                      <Link className="dropdown-item" href="#">
          7
                      </Link>
                    </li>
                    <li  onClick={() => {
              
                      setRoom(["8"]);
                  
                  }}>
                      <Link className="dropdown-item" href="#">
                    8
                      </Link>
                    </li>
                    <li  onClick={() => {
               
                      setRoom(["9"]);
                 
                  }}>
                      <Link className="dropdown-item" href="#">
                 9+
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
         

              <div className=" list-view-dropdown-border mt-2">
                {/* <div className="list-view-dropdown-border"> */}
                <div className="dropdown">
                  <Link
                    className="dropdown-btn-list-view dropdown-toggle1"
                    href="#"
                    role="button"
                    id="dropdownMenuLink"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
               {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_rental_period"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_rental_period"
                                )[0]["value"] || "lbl_rental_period"
                              : "lbl_rental_period"
                            : "lbl_rental_period"}
                    <i className="arrow down"></i>
                  </Link>

                  <ul
                    className="dropdown-menu"
                    aria-labelledby="dropdownMenuLink"
                  >
                    <li    >
                      <Link className="dropdown-item" href="#">
                      <div
                  className="field-group1 p-0  "
                  style={{ borderBottom: "none" }}
                >
                      <label htmlFor="15">
                    {frontLabelsName
                      ? frontLabelsName.filter((e) => e.key == "lbl_available_now")
                          .length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_available_now"
                          )[0]["value"] || "lbl_available_now"
                        : "lbl_available_now"
                      : "lbl_available_now"}
                  </label>
                  <input
                    id="15"
                    type="checkbox"
                    value={rentalPeriod}
                    onChange={() => {
                      if (rentalPeriod !== "1") {
                        setRentalPeriod("1");
                      } else {
                        setRentalPeriod("");
                      }
                    }}
                    checked={rentalPeriod === "1"}
                  />
                  </div>
                      </Link>
                    </li>
  
                    <li>
                      <Link className="dropdown-item" href="#">
                      <div
                  className="field-group1 p-0"
                  style={{ borderBottom: "none" }}
                >
                      <label htmlFor="17" className="pe-2">
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_long_term_rental"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_long_term_rental"
                          )[0]["value"] || "lbl_long_term_rental"
                        : "lbl_long_term_rental"
                      : "lbl_long_term_rental"}
                  </label>
                  <input
                    id="17"
                    type="checkbox"
                    value={rentalPeriod}
                    onChange={() => {
                      if (rentalPeriod !== "3") {
                        setRentalPeriod("3");
                      } else {
                        setRentalPeriod("");
                      }
                    }}
                    checked={rentalPeriod === "3"}
                  />
                  </div>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
             
                       <div className=" btn-list-view list-view-dropdown-border1 d-flex justify-content-start">
                {/* <div className="list-view-dropdown-border"> */}
                <div className="dropdown "     onClose={handleClose}>
                <button
                          className="advace-btn"
                          onClose={handleClose}
                          onClick={handlePropertyField}
                          type="button"
                          style={{}}
                        >
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == "lbl_advanced")
                                .length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_advanced"
                                )[0]["value"] || "lbl_advanced"
                              : "lbl_advanced"
                            : "lbl_advanced"}
                        </button>

                  {open1 && (
                          <div className="advanced-btn-content" style={{position:"absolute",top:"40px",right:"0px",zIndex:50,height:"450px",overflowY:"scroll",overflowX:"hidden"}}>
                            <div>
                              <FormGroup row className="set-bg-feild">
                                <Col sm={12}>
                                  <select
                                    name="select"
                                    id="inhabitants"
                                    className={`set-bg-input ${!inhabitants ? "has-placeholder" : ""}`}
                                    style={{ width: "100%" }}
                                    value={inhabitants}
                                    onChange={(e) => {
                                      setPage(1);
                                      setInhabitants(e.target.value);
                                    }}
                                  >
                                    <option value={""}>
                                      {frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) =>
                                              e.key ==
                                              "lbl_allowed_number_of_inhabitants"
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) =>
                                                e.key ==
                                                "lbl_allowed_number_of_inhabitants"
                                            )[0]["value"] ||
                                            "lbl_allowed_number_of_inhabitants"
                                          : "lbl_allowed_number_of_inhabitants"
                                        : "lbl_allowed_number_of_inhabitants"}
                                    </option>
                                    <option value={"agreement"}>
                                      {frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_agreement"
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_agreement"
                                            )[0]["value"] || "lbl_agreement"
                                          : "lbl_agreement"
                                        : "lbl_agreement"}
                                    </option>
                                    <option value={"1"}>1</option>
                                    <option value={"2"}>2</option>
                                    <option value={"3"}>3</option>
                                    <option value={"4"}>4</option>
                                    <option value={"5"}>5</option>
                                    <option value={"6"}>6</option>
                                    <option value={"7"}>7</option>
                                    <option value={"8"}>8</option>
                                    <option value={"9"}>9</option>
                                    <option value={"10"}>10</option>
                                  </select>
                                </Col>
                              </FormGroup>
                              <FormGroup row className="set-bg-feild ">
                                <Col sm={12}>
                                  <select
                                    name="select"
                                    id="gender"
                                    className={`set-bg-input ${!gender ? "has-placeholder" : ""}`}
                                    style={{ width: "100%" }}
                                    value={gender}
                                    onChange={(e) => {
                                      setPage(1);
                                      setGender(e.target.value);
                                    }}
                                  >
                                    <option value={""}>
                                      {frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_select_gender"
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) =>
                                                e.key == "lbl_select_gender"
                                            )[0]["value"] || "lbl_select_gender"
                                          : "lbl_select_gender"
                                        : "lbl_select_gender"}
                                    </option>
                                    <option value={0}>
                                      {frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_all_gender"
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_all_gender"
                                            )[0]["value"] || "lbl_all_gender"
                                          : "lbl_all_gender"
                                        : "lbl_all_gender"}
                                    </option>
                                    <option value={1}>
                                      {" "}
                                      {frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_only_male"
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_only_male"
                                            )[0]["value"] || "lbl_only_male"
                                          : "lbl_only_male"
                                        : "lbl_only_male"}
                                    </option>
                                    <option value={2}>
                                      {" "}
                                      {frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_only_female"
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_only_female"
                                            )[0]["value"] || "lbl_only_female"
                                          : "lbl_only_female"
                                        : "lbl_only_female"}
                                    </option>
                                    <option value={3}>
                                      {" "}
                                      {frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_other"
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_other"
                                            )[0]["value"] || "lbl_other"
                                          : "lbl_other"
                                        : "lbl_other"}
                                    </option>
                                    <option value={4}>
                                      {" "}
                                      {frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_couples"
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_couples"
                                            )[0]["value"] || "lbl_couples"
                                          : "lbl_couples"
                                        : "lbl_couples"}
                                    </option>
                                  </select>
                                </Col>
                              </FormGroup>
                              <div className="set-btn-no">
                                <h6 className="pt-0">
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_smoking"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_smoking"
                                        )[0]["value"] || "lbl_smoking"
                                      : "lbl_smoking"
                                    : "lbl_smoking"}
                                </h6>
                                <div className="d-flex justify-content-between field-group-div">
                                  <div className="field-group10 d-flex align-items-center">
                                    <label htmlFor="smoking1">
                                      {frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_yes"
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_yes"
                                            )[0]["value"] || "lbl_yes"
                                          : "lbl_yes"
                                        : "lbl_yes"}
                                    </label>
                                    <input
                                      id="smoking1"
                                      type="checkbox"
                                      value={smoking}
                                      onChange={() => {
                                        if (smoking !== "1") {
                                          setPage(1);
                                          setSmoking("1");
                                        } else {
                                          setPage(1);
                                          setSmoking("");
                                        }
                                      }}
                                      checked={smoking === "1"}
                                      className="ms-1"
                                    />
                                  </div>
                                  <div className="field-group10 d-flex align-items-center">
                                    <label htmlFor="smoking2">
                                      {frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_no"
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_no"
                                            )[0]["value"] || "lbl_no"
                                          : "lbl_no"
                                        : "lbl_no"}
                                    </label>
                                    <input
                                      id="smoking2"
                                      type="checkbox"
                                      value={smoking}
                                      onChange={() => {
                                        if (smoking !== "2") {
                                          setPage(1);
                                          setSmoking("2");
                                        } else {
                                          setPage(1);
                                          setSmoking("");
                                        }
                                      }}
                                      checked={smoking === "2"}
                                      className="ms-1"
                                    />
                                  </div>
                                  <div className="field-group10 d-flex align-items-center">
                                    <label htmlFor="smoking3">
                                      {frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_agreement"
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_agreement"
                                            )[0]["value"] || "lbl_agreement"
                                          : "lbl_agreement"
                                        : "lbl_agreement"}
                                    </label>
                                    <input
                                      id="smoking3"
                                      type="checkbox"
                                      value={smoking}
                                      onChange={() => {
                                        if (smoking !== "3") {
                                          setPage(1);
                                          setSmoking("3");
                                        } else {
                                          setPage(1);
                                          setSmoking("");
                                        }
                                      }}
                                      checked={smoking === "3"}
                                      className="ms-1"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="set-btn-no pt-2">
                                <h6>
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_pets"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_pets"
                                        )[0]["value"] || "lbl_pets"
                                      : "lbl_pets"
                                    : "lbl_pets"}
                                </h6>
                                <div className="d-flex justify-content-between field-group-div">
                                  <div className="field-group10 d-flex align-items-center">
                                    <label htmlFor="pets1">
                                      {frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_yes"
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_yes"
                                            )[0]["value"] || "lbl_yes"
                                          : "lbl_yes"
                                        : "lbl_yes"}
                                    </label>
                                    <input
                                      id="pets1"
                                      type="checkbox"
                                      value={pets}
                                      onChange={() => {
                                        if (pets !== "1") {
                                          setPage(1);
                                          setPets("1");
                                        } else {
                                          setPage(1);
                                          setPets("");
                                        }
                                      }}
                                      checked={pets === "1"}
                                      className="ms-1"
                                    />
                                  </div>
                                  <div className="field-group10 d-flex align-items-center">
                                    <label htmlFor="pets2">
                                      {frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_no"
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_no"
                                            )[0]["value"] || "lbl_no"
                                          : "lbl_no"
                                        : "lbl_no"}
                                    </label>
                                    <input
                                      id="pets2"
                                      type="checkbox"
                                      value={pets}
                                      onChange={() => {
                                        if (pets !== "2") {
                                          setPage(1);
                                          setPets("2");
                                        } else {
                                          setPage(1);
                                          setPets("");
                                        }
                                      }}
                                      checked={pets === "2"}
                                      className="ms-1"
                                    />
                                  </div>
                                  <div className="field-group10 d-flex align-items-center">
                                    <label htmlFor="pets3">
                                      {frontLabelsName
                                        ? frontLabelsName.filter(
                                            (e) => e.key == "lbl_agreement"
                                          ).length > 0
                                          ? frontLabelsName.filter(
                                              (e) => e.key == "lbl_agreement"
                                            )[0]["value"] || "lbl_agreement"
                                          : "lbl_agreement"
                                        : "lbl_agreement"}
                                    </label>
                                    <input
                                      id="pets3"
                                      type="checkbox"
                                      value={pets}
                                      onChange={() => {
                                        if (pets !== "3") {
                                          setPage(1);
                                          setPets("3");
                                        } else {
                                          setPage(1);
                                          setPets("");
                                        }
                                      }}
                                      checked={pets === "3"}
                                      className="ms-1"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <CheckboxTree
                              nodes={propertyFieldNodes}
                              checked={checkedPropertyFieldTree}
                              expanded={expandedPropertyFieldTree}
                              expandOnClick={true}
                              onClick={(checkedPropertyFieldTree) =>
                                setClickedPropertyFieldTree(
                                  checkedPropertyFieldTree
                                )
                              }
                              onCheck={(checkedPropertyFieldTree) => {
                                setCheckedPropertyFieldTree(
                                  checkedPropertyFieldTree
                                );
                                setFilterPropertyFieldText(
                                  checkedPropertyFieldTree.toString()
                                );
                                setPage(1);
                              }}
                              onExpand={(expandedPropertyFieldTree) =>
                                setExpandedPropertyFieldTree(
                                  expandedPropertyFieldTree
                                )
                              }
                              icons={icons}
                              // nativeCheckboxes={true}
                            />
                            
                          </div>
                        )}
         
                    </div>
           
            </div>
    
        </div>
      </div>
    </div>
    // </div>
  );
};
const mapStateToProps = (state) => ({
  properties: state.properties,
  auth: state.auth,
  subscriptions: state.subscription,
  label: state.language,
});
export default connect(mapStateToProps, {dropdownPropertyField})(FilterNavbar);
